import { seDateTimeConfig } from './date-time-config'
import { extendClass } from './extend-class'
import { DateTime } from 'luxon'
import { SeDateTimeFormatter } from './date-time-formatter'
import { SeDateFormatter } from './date-formatter'
import {
  SeDateTimeString,
  SeDateTimeOptions,
  SeDateTimeFormat,
  SeDateTimeModifier
} from './date-time-types'

export abstract class SeTimeFormatter {

  public initTime(value: SeDateTimeString, options: SeDateTimeOptions): void {
    this.initDate(value, options)
    this.allDay = options.allDay
    this.timeTbd = !this.allDay && options.timeTbd
    this.addConditions([
      { [SeDateTimeFormat.NonZeroMinutes]: luxon => luxon.minute !== 0 },
      { [SeDateTimeFormat.NonDeviceZone]: () => this.nonDeviceZone },
    ])
  }

  public get shortDateTime(): string {
    return this.format(SeDateTimeFormat.ShortDateTime, () => true)
  }

  public get dateTime(): string {
    return this.format(SeDateTimeFormat.DateTime, () => true)
  }

  public get fullDateTime(): string {
    return this.format(SeDateTimeFormat.FullDateTime, () => true)
  }

  public get time(): string {
    return this.format(SeDateTimeFormat.Time, () => true)
  }

  public get zone(): string {
    return this.format(SeDateTimeFormat.Zone)
  }

  private get nonDeviceZone(): boolean {
    return seDateTimeConfig.deviceZone !== this.startLuxon.zoneName
  }

}

export interface SeTimeFormatter extends SeDateTimeFormatter, SeDateFormatter {}
extendClass(SeTimeFormatter, SeDateTimeFormatter, SeDateFormatter)
